export default __webpack_public_path__ + "static/media/Cash.d783cc97.svg";